import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/signup")({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
